export default __webpack_public_path__ + "static/01 - Foto Ariel-d2bb3e1aeea6dd37a2673501240cf0fd.jpg";